module.exports = __webpack_public_path__ + "static/media/wishlist-solid.aeb0edbd.svg";